document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".site-header");
  if (!header) return;

  const trigger = header.querySelector("[data-mega-menu-toggle]");
  const megaMenu = header.querySelector("[data-mega-menu]");

  if (!trigger || !megaMenu) return;

  const categories = megaMenu.querySelectorAll("[data-mega-category]");
  const panels = megaMenu.querySelectorAll("[data-mega-panel]");

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* ========================================================
     OPEN / CLOSE
  ======================================================== */

  function openMegaMenu() {
    megaMenu.classList.add("is-open");
    megaMenu.setAttribute("aria-hidden", "false");
    megaMenu.inert = false;

    trigger.setAttribute("aria-expanded", "true");

    updateActiveCarousel();
  }

  function closeMegaMenu() {
    megaMenu.classList.remove("is-open");
    megaMenu.setAttribute("aria-hidden", "true");
    megaMenu.inert = true;

    trigger.setAttribute("aria-expanded", "false");
  }

  trigger.addEventListener("click", () => {
    const isOpen = megaMenu.classList.contains("is-open");

    if (isOpen) {
      closeMegaMenu();
    } else {
      openMegaMenu();
    }
  });

  /* ========================================================
     COLLECTION SWITCHING
  ======================================================== */

  categories.forEach((category) => {
    category.addEventListener("click", () => {
      const categoryId = category.dataset.categoryId;

      categories.forEach((item) => {
        const isActive = item.dataset.categoryId === categoryId;

        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", String(isActive));
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.panelId === categoryId;

        panel.classList.toggle("is-active", isActive);
      });

      updateActiveCarousel();
    });
  });

  /* ========================================================
     CAROUSEL
  ======================================================== */

  function updateCarousel(panel) {
    const track = panel.querySelector(".shop-mega-menu__products");
    const cards = [...panel.querySelectorAll(".shop-mega-menu__product")];

    const counter = panel.querySelector("[data-mega-counter]");
    const prevButton = panel.querySelector("[data-mega-prev]");
    const nextButton = panel.querySelector("[data-mega-next]");

    if (!track || !counter || !prevButton || !nextButton) return;

    const total = cards.length;

    if (total === 0) {
      counter.textContent = "00 / 00";
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const currentScroll = track.scrollLeft;

    let currentIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const distance = Math.abs(
        card.offsetLeft - track.offsetLeft - currentScroll,
      );

      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = index;
      }
    });

    const current = String(currentIndex + 1).padStart(2, "0");
    const totalText = String(total).padStart(2, "0");

    counter.textContent = `${current} / ${totalText}`;

    prevButton.disabled = currentScroll <= 2;
    nextButton.disabled = currentScroll >= maxScroll - 2;
  }

  function updateActiveCarousel() {
    const activePanel = megaMenu.querySelector(
      ".shop-mega-menu__panel.is-active",
    );

    if (activePanel) {
      updateCarousel(activePanel);
    }
  }

  panels.forEach((panel) => {
    const track = panel.querySelector(".shop-mega-menu__products");
    const cards = [...panel.querySelectorAll(".shop-mega-menu__product")];

    const prevButton = panel.querySelector("[data-mega-prev]");
    const nextButton = panel.querySelector("[data-mega-next]");

    if (!track || !prevButton || !nextButton) return;

    function scrollToCard(direction) {
      if (!cards.length) return;

      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const cardWidth = cards[0].getBoundingClientRect().width;

      const distance = cardWidth + gap;

      track.scrollBy({
        left: direction * distance,
        behavior: (document.documentElement.dataset.animations === "false" || reducedMotion.matches) ? "instant" : "smooth",
      });
    }

    prevButton.addEventListener("click", () => {
      scrollToCard(-1);
    });

    nextButton.addEventListener("click", () => {
      scrollToCard(1);
    });

    track.addEventListener(
      "scroll",
      () => {
        updateCarousel(panel);
      },
      { passive: true },
    );
  });

  window.addEventListener("resize", updateActiveCarousel);

  /* ========================================================
     OUTSIDE CLICK / ESCAPE
  ======================================================== */

  document.addEventListener("click", (event) => {
    if (!header.contains(event.target)) {
      closeMegaMenu();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && megaMenu.classList.contains("is-open")) {
      closeMegaMenu();
      trigger.focus();
    }
  });

  megaMenu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMegaMenu);
  });
});
